/**
 * Helper functions for determining layout behavior based on user permissions
 */

export const isClientUser = (userPermissions?: { groups?: string[] }): boolean => {
  if (!userPermissions?.groups) return false;
  return userPermissions.groups.includes('client_user') || userPermissions.groups.includes('client_admin');
};

export const shouldUseNewLayout = (userPermissions?: { groups?: string[] }): boolean => {
  // Client users should NOT use the new layout
  return !isClientUser(userPermissions);
};

export const isOrgAdmin = (userPermissions?: { groups?: string[] }): boolean => {
  if (!userPermissions?.groups) return false;
  return userPermissions.groups.includes('org_admin');
};

export const getActivePage = (pathname: string): string => {
  // Extract the base path for determining active page
  const path = pathname.split('?')[0]; // Remove query params
  return path;
};